module.exports = __webpack_public_path__ + "img/inside-4.229a10bb.png";